import C2101Const from './C2101Const'

export default C2101Const.getStore()
